import React, { useState } from 'react';

import './ARPromotion.css';

const DISMISSAL_KEY = 'ar-promotion-dismissed';

export default function ARPromotion({ href = '/chair-guide' }) {
  const [isVisible, setIsVisible] = useState(() => {
    try {
      return window.sessionStorage.getItem(DISMISSAL_KEY) !== 'true';
    } catch (error) {
      return true;
    }
  });

  const dismiss = () => {
    try {
      window.sessionStorage.setItem(DISMISSAL_KEY, 'true');
    } catch (error) {
      // Keep the close action functional when storage is unavailable.
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <section className="ar-promotion" aria-label="Augmented reality chair preview">
      <div className="ar-promotion-content">
        <span className="ar-promotion-badge" aria-hidden="true">AR</span>
        <div>
          <p className="ar-promotion-eyebrow">See it in your space</p>
          <p className="ar-promotion-copy">
            Build your chair and preview it with augmented reality before you order.
          </p>
        </div>
        <a className="ar-promotion-link" href={href}>Try AR in Build a Chair <span aria-hidden="true">→</span></a>
        <button
          className="ar-promotion-close"
          type="button"
          aria-label="Close augmented reality announcement"
          onClick={dismiss}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </section>
  );
}
